import { Box, styled } from "@mui/material";

interface InputLabelProps {
  disabled?: boolean;
}

export const InputLabel = styled("label")<InputLabelProps>(({ disabled, theme }) => ({
  fontSize: "16px",
  fontWeight: 500,
  lineHeight: "23px",
  paddingBottom: "4px",
  color: disabled ? theme.palette.text.disabled : theme.palette.text.primary,
}));

export const RelativeContainer = styled(Box)({
  position: "relative",
});

export const FormErrorMessage = styled("span")(({ theme }) => ({
  position: "absolute",
  fontSize: "12px",
  color: theme.palette.error.main,
}));
